/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CloudRegion } from '../models/CloudRegion';

export class ListInventoryBackupRegionsResponse {
  'regions': Array<CloudRegion>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "regions",
      "baseName": "regions",
      "type": "Array<CloudRegion>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListInventoryBackupRegionsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

